import React, { useEffect, useState, useContext } from 'react';
import { Table, TableCell, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import {
  GetKindNoNameSetType,
  GetNameItemSetType,
  GetLogIntSetType,
  GetmulItems,
  GetDataUnitType,
  PLCcollectSettingType,
  KIND_NO_NAME_SET,
  NAME_ITEM_SET,
  LOG_INT_SET,
  MulDataType,
  DATA_UNIT,
  GetConanMeasureName,
} from './CollectSettingDefine';
import { NAME_DEV_SET, GetNameDevSetList } from '../../../../function/NameDevSetModel';

import { useTranslation, UseTranslationResponse } from 'react-i18next';
import StackCell, { CellSizeContainer } from '../../../atoms/Cell/StackCell';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import ItemComboBoxStr, { ComboBoxItemTypeS } from '../../../atoms/ComboBox/ItemComboBoxStr';
import { TFunction } from 'i18next';
import { useModal } from '../../../../function/useModal';
import CollectSettingItemIoTDialog, { CollectSettingItemIoTDialogResponse } from './CollectSettingItemIoTDialog';
import { SpeedKind, MeasureHighKind } from '../../../../Constant';

type CollectGridBodyIoTProps = {
  plcSettingList: PLCcollectSettingType[];
  isDispPLC: boolean;
  isOrderDevice: boolean;
  update: (target: PLCcollectSettingType, index: number) => void;
  updateStartTime: (devIndex: string, startTime: Date) => void;
  updateMotorSensor: (target: PLCcollectSettingType, index: number, chk: boolean) => boolean;
  updateRotClc: (target: PLCcollectSettingType, index: number, chk: boolean) => boolean;
};

const useStyles = makeStyles(
  createStyles({
    '@global': {
      '.MuiTableCell-body': { color: 'inherit' },
    },
    tableHeader: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      borderCollapse: `collapse`,
    },
    fixColumn: {
      borderWidth: '0px',
      outlineWidth: '1px',
      outlineColor: '#dcdcdc',
      outlineStyle: 'solid',
      padding: '0px',
      paddingLeft: '5px',
      position: 'sticky',
      zIndex: 10,
      backgroundColor: 'white',
    },
    tableTd: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0px',
      paddingLeft: '5px',
      borderCollapse: `collapse`,
      zIndex: 0,
    },
    table_no_border_td: {
      borderTop: '0px',
      borderBottom: '0px',
      borderLeft: '0px',
      borderRight: '1px',
      borderRightStyle: 'solid',
      borderRightColor: '#dcdcdc',
      padding: '0px',
      minWidth: '80px',
      borderCollapse: `collapse`,
    },
    textAlignRightCell: {
      textAlign: 'right',
    },
    textAlignCenterCell: {
      textAlign: 'center',
    },
    labelStyle: {
      fontSize: '12px',
    },
    //テキスト
    textField: {
      flexGrow: 1,
      height: '100%',
      width: '98%',
      border: 'none',
      padding: '0px',
      backgroundColor: 'transparent',
    },
    selectRow: {
      background: '#7fffd4',
    },
  })
);

const CollectGridBodyIoT: React.FC<CollectGridBodyIoTProps> = (props: CollectGridBodyIoTProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  // const [plcSettingList, setPlcSettingList] = React.useState<PLCcollectSettingType[]>([]);
  const [kindNoNameList, setKindNoNameList] = React.useState<KIND_NO_NAME_SET[]>([]);
  const [nameDevList, setNameDevList] = React.useState<NAME_DEV_SET[]>([]);
  const [nameItemList, setNameItemList] = React.useState<NAME_ITEM_SET[]>([]);
  const [logIntList, setLogIntList] = React.useState<LOG_INT_SET[]>([]);
  const [mulList, setMULList] = React.useState<MulDataType[]>([]);
  const [dataUnitList, setDataUnitList] = React.useState<DATA_UNIT[]>([]);
  const [measCombos, setMeasCombos] = useState<ComboBoxItemTypeS[]>([]);
  const [devCombos, setDevCombos] = useState<ComboBoxItemTypeS[]>([]);
  const [itemCombos, setItemCombos] = useState<ComboBoxItemTypeS[]>([]);
  const [mulCombos, setMulCombos] = useState<ComboBoxItemTypeS[]>([]);
  const [unitCombos, setUnitCombos] = useState<ComboBoxItemTypeS[]>([]);
  const [logIntCombos, setLogIntCombos] = useState<ComboBoxItemTypeS[]>([]);
  const avgCombos: ComboBoxItemType[] = [
    { index: 0, name: t('CollectGridBody.加算平均', '加算平均') },
    { index: 1, name: t('CollectGridBody.指数平均', '指数平均') },
    { index: 2, name: t('CollectGridBody.ピークホールド', 'ピークホールド') },
  ];
  const [plcNo, setPlcNo] = useState<number>(0);
  const [aiCard, setAiCard] = useState<number>(0);
  const [aiCh, setAiCh] = useState<number>(0);
  const [cursorIndex, setCursorIndex] = useState<number>(-1);

  console.debug('MeasureGridBody');
  console.debug(props.plcSettingList.length);

  useEffect(() => {
    var a = GetKindNoNameSetType();
    var b = GetNameDevSetList();
    var c = GetNameItemSetType();
    var d = GetLogIntSetType();
    var e = GetmulItems();
    var f = GetDataUnitType();

    Promise.all([a, b, c, d, e, f]).then((ret) => {
      //console.debug(['Promise.all : ret', ret]);
      console.debug(ret[0]);
      console.debug(ret[1]);
      console.debug(ret[2]);
      console.debug(ret[3]);
      console.debug(ret[4]);
      console.debug(ret[5]);

      setKindNoNameList(ret[0]);
      setNameDevList(ret[1]);
      setNameItemList(ret[2]);
      setLogIntList(ret[3]);
      setMULList(ret[4]);
      setDataUnitList(ret[5]);

      //振動Row取得
      //コナンエアの場合SPEED２の振動と同じ名前を付ける
      let conaMesName = GetConanMeasureName(ret[0]);
      setMeasCombos(
        ret[0].map<ComboBoxItemTypeS>((ci) => {
          if (ci.SPEED === SpeedKind.SPEED_CONAN) {
            return { key: `${ci.NAME_NO}_${ci.SPEED}`, name: conaMesName };
          } else {
            return { key: `${ci.NAME_NO}_${ci.SPEED}`, name: ci.MES_NAME };
          }
        })
      );
      //機器番号 実装のみ選択可
      setDevCombos(
        ret[1]
          .filter((ci) => ci.EST === 1)
          .map<ComboBoxItemTypeS>((ci) => {
            return { key: `${ci.DEV_INDEX}`, name: ci.DEV_NO };
          })
      );
      //項目名称 実装のみ選択可
      setItemCombos(
        ret[2]
          .filter((ci) => ci.EST === 1)
          .map<ComboBoxItemTypeS>((ci) => {
            return { key: `${ci.ITM_NAME_NO}`, name: ci.ITM_NAME };
          })
      );
      setLogIntCombos(
        ret[3].map<ComboBoxItemTypeS>((ci) => {
          return { key: `${ci.LOG_INT}`, name: ci.DSP_STR };
        })
      );
      setMulCombos(
        ret[4].map<ComboBoxItemTypeS>((ci) => {
          return { key: `${ci.code}`, name: ci.value };
        })
      );
      setUnitCombos(
        ret[5].map<ComboBoxItemTypeS>((ci) => {
          return { key: ci.UNIT_STR, name: ci.UNIT_STR };
        })
      );
    });
  }, []);

  const updateCursor = (index: number) => {
    setCursorIndex(index);
  };

  // <!-- ItemCheckBox value={props.item.IsExecute} label={t('CollectGridBody.実行','実行')} onChangeEvent={(e) => onChangeCheckBox(e, props.item)} /-->
  const buttonFace = t('CollectGridBody.変更', '変更');
  return (
    <React.Fragment>
      {props.plcSettingList?.map((row, idx) => (
        <CollectGridRow
          key={`${row.PLCNo}_${row.AICardNo}_${row.ChannelNo}`}
          item={row}
          index={idx}
          selectIndex={cursorIndex}
          isDispPLC={props.isDispPLC}
          kindNoNameList={kindNoNameList}
          nameDevList={nameDevList}
          nameItemList={nameItemList}
          logIntList={logIntList}
          mulList={mulList}
          dataUnitList={dataUnitList}
          measCombos={measCombos}
          devCombos={devCombos}
          itemCombos={itemCombos}
          mulCombos={mulCombos}
          unitCombos={unitCombos}
          logIntCombos={logIntCombos}
          avgCombos={avgCombos}
          t={t}
          update={props.update}
          updateStartTime={props.updateStartTime}
          updateMotorSensor={props.updateMotorSensor}
          updateRotClc={props.updateRotClc}
          buttonFace={buttonFace}
          updateCursor={updateCursor}
        />
      ))}
    </React.Fragment>
  );
};

type CollectGridRowProps = {
  item: PLCcollectSettingType;
  index: number;
  selectIndex: number;
  isDispPLC: boolean;
  kindNoNameList: KIND_NO_NAME_SET[];
  nameDevList: NAME_DEV_SET[];
  nameItemList: NAME_ITEM_SET[];
  logIntList: LOG_INT_SET[];
  mulList: MulDataType[];
  dataUnitList: DATA_UNIT[];
  measCombos: ComboBoxItemTypeS[];
  devCombos: ComboBoxItemTypeS[];
  itemCombos: ComboBoxItemTypeS[];
  mulCombos: ComboBoxItemTypeS[];
  unitCombos: ComboBoxItemTypeS[];
  logIntCombos: ComboBoxItemTypeS[];
  avgCombos: ComboBoxItemType[];
  t: TFunction;
  update: (target: PLCcollectSettingType, index: number) => void;
  updateStartTime: (devIndex: string, startTime: Date) => void;
  updateMotorSensor: (target: PLCcollectSettingType, index: number, chk: boolean) => boolean;
  updateRotClc: (target: PLCcollectSettingType, index: number, chk: boolean) => boolean;
  buttonFace: string;
  updateCursor: (index: number) => void;
};

const IsEditItemDev = (isIoT: boolean): boolean => {
  return !isIoT;
};
const IsEditItemSignal = (ch: string): boolean => {
  return '345'.indexOf(ch) >= 0;
};
const IsItemRST = (itemNo: number): boolean => {
  return itemNo >= 3 && itemNo <= 5;
};

const CollectGridRow: React.FC<CollectGridRowProps> = (props) => {
  const classes = useStyles();

  const [item, setItem] = useState<PLCcollectSettingType>(props.item);

  const cnt = new CellSizeContainer();

  const [flgEdit, editDlg] = useModal<CollectSettingItemIoTDialogResponse>();
  const editdlgElem = flgEdit ? (
    <CollectSettingItemIoTDialog
      dialog={editDlg}
      target={item}
      index={props.index}
      measCombos={props.measCombos}
      devCombos={props.devCombos}
      itemCombos={props.itemCombos}
      mulCombos={props.mulCombos}
      unitCombos={props.unitCombos}
      logIntCombos={props.logIntCombos}
      avgCombos={props.avgCombos}
      kindNoNameList={props.kindNoNameList}
      nameDevList={props.nameDevList}
      nameItemList={props.nameItemList}
      logIntList={props.logIntList}
      mulList={props.mulList}
      dataUnitList={props.dataUnitList}
      updateMotorSensor={props.updateMotorSensor}
      updateRotClc={props.updateRotClc}
    />
  ) : null;

  const doubleClick = () => {
    console.log('mouse dbl click');
    editDlg.open().apply((resp) => {
      props.update(resp.result, props.index);
      setItem(resp.result);
    });
  };

  const selectRow = () => {
    props.updateCursor(props.index);
  };

  const lineAttr = props.index == props.selectIndex ? classes.selectRow : '';

  return (
    <>
      <TableRow className={lineAttr}>
        <StackCell
          className={classes.fixColumn + ' ' + classes.textAlignCenterCell + ' ' + lineAttr}
          container={cnt}
          width={50}
          top={-1}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {props.index + 1}
        </StackCell>
        <StackCell
          className={classes.fixColumn + ' ' + classes.textAlignCenterCell + ' ' + lineAttr}
          container={cnt}
          width={40}
          top={-1}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          <div>{item.IsExecute == true ? '✔' : ''}</div>
        </StackCell>
        <StackCell
          className={classes.fixColumn + ' ' + lineAttr}
          container={cnt}
          width={100}
          top={-1}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {/* {props.devCombos.find((d) => d.key == item.MachineIndex)?.name} */}
          {props.nameDevList.find((it) => it.DEV_INDEX === Number(item.MachineIndex))?.DEV_NO}
        </StackCell>
        <StackCell
          className={classes.fixColumn + ' ' + lineAttr}
          container={cnt}
          width={100}
          top={-1}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {props.nameDevList.find((it) => it.DEV_INDEX === Number(item.MachineIndex))?.DEV_NAME}
        </StackCell>
        <StackCell
          className={classes.fixColumn + ' ' + lineAttr}
          container={cnt}
          width={40}
          top={-1}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {item.ChannelNo}
        </StackCell>
        <StackCell
          className={classes.fixColumn + ' ' + lineAttr}
          container={cnt}
          width={160}
          top={-1}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {props.item.UnitName}
        </StackCell>
        <StackCell
          className={classes.fixColumn + ' ' + lineAttr}
          container={cnt}
          width={120}
          top={-1}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {props.measCombos.find((d) => d.key == `${item.NameNo}_${item.Speed}`)?.name}
        </StackCell>
        {/*項目名称 */}
        <TableCell className={classes.tableTd} onClick={selectRow} onDoubleClick={doubleClick} width={110}>
          {item.NameNo != 0 ? props.itemCombos.find((it) => it.key == item.ItemNameNo.toString())?.name : ''}
        </TableCell>
        <TableCell className={classes.tableTd} onClick={selectRow} onDoubleClick={doubleClick}>
          <Table>
            <TableRow>
              <TableCell className={classes.table_no_border_td} style={{ width: '100px' }}>
                <div className={classes.textField}>{item.NameNo != 0 ? item.DigitalValueUpper : ''}</div>
              </TableCell>
              <TableCell className={classes.table_no_border_td} style={{ width: '100px' }}>
                <div className={classes.textField}>{item.NameNo != 0 ? item.DigitalValueLower : ''}</div>
              </TableCell>
            </TableRow>
          </Table>
        </TableCell>
        <TableCell className={classes.tableTd} onClick={selectRow} onDoubleClick={doubleClick}>
          <Table>
            <TableRow>
              <TableCell className={classes.table_no_border_td} style={{ width: '100px' }}>
                <div className={classes.textField}>{item.NameNo != 0 ? item.EngineeringValueUpper : ''}</div>
              </TableCell>
              <TableCell className={classes.table_no_border_td} style={{ width: '100px' }}>
                <div className={classes.textField}>{item.NameNo != 0 ? item.EngineeringValueLower : ''}</div>
              </TableCell>
            </TableRow>
          </Table>
        </TableCell>
        <TableCell
          className={classes.tableTd + ' ' + classes.textAlignRightCell}
          width={20}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {item.NameNo != 0 ? props.mulCombos.find((ml) => ml.key == item.Mul.toString())?.name : ''}
        </TableCell>
        <TableCell
          className={classes.tableTd + ' ' + classes.textAlignCenterCell}
          width={40}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          {item.NameNo != 0 ? props.unitCombos.find((un) => un.key == item.UnitSymbol)?.name : ''}
        </TableCell>
        {/* <TableCell className={classes.tableTd + ' ' + classes.textAlignCenterCell} onDoubleClick={doubleClick}>
        { props.buttonFace}
          {/* <Button variant="outlined" color="secondary" onClick={(e) => dispJudge()}>
            {props.t('CollectGridBody.変更', '変更')}
          </Button>
        </TableCell> */}
        {/* 温度上限異常 */}
        {/* <TableCell
          className={classes.table_no_border_td}
          style={{ width: '124px' }}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          <div className={classes.textField}>{item.NameNo != 0 ? item.RealtimeTrendValueUpper : ''}</div>
        </TableCell> */}
        {/* 温度上上限異常 */}
        {/* <TableCell
          className={classes.table_no_border_td}
          style={{ width: '124px' }}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          <div className={classes.textField}>{item.NameNo != 0 ? item.RealtimeTrendValueUpperUpper : ''}</div>
        </TableCell> */}
        <TableCell className={classes.tableTd} onClick={selectRow} onDoubleClick={doubleClick}>
          {item.NameNo != 0 ? props.avgCombos.find((av) => av.index == item.AvgPrc)?.name : ''}
        </TableCell>
        {/* <TableCell
          className={classes.tableTd + ' ' + classes.textAlignCenterCell}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          <div>{item.NameNo != 0 && item.EnvSav == true ? '✔' : ''}</div>
          <input type="checkbox" checked={item.EnvSav} defaultChecked={item.EnvSav} />
        </TableCell> */}
        <TableCell
          className={classes.tableTd + ' ' + classes.textAlignCenterCell}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          <div>{item.NameNo != 0 && item.StartDet == 1 ? '✔' : ''}</div>
          {/* <input type="checkbox" checked={item.StartDet == 1} defaultChecked={item.StartDet === 1} />*/}
        </TableCell>
        <TableCell
          className={classes.tableTd + ' ' + classes.textAlignCenterCell}
          onClick={selectRow}
          onDoubleClick={doubleClick}
        >
          <div>{item.NameNo != 0 && item.RotClc == true ? '✔' : ''}</div>
          {/* <input type="checkbox" checked={item.RotClc} defaultChecked={item.RotClc} /> */}
        </TableCell>
        <TableCell className={classes.tableTd} onClick={selectRow} onDoubleClick={doubleClick}>
          {item.NameNo != 0 ? item.Note : ''}
        </TableCell>
      </TableRow>
      {/* {jdgdlgElem} */}
      {editdlgElem}
    </>
  );
};

export default CollectGridBodyIoT;
